/**
 * Sekcja "Per miesiąc" - tabela `per_miesiac` z podsumowania
 * (ile w portalu, ile brakujacych faktur/korekt w danym miesiacu).
 */
import React from 'react';
import { formatujMiesiac } from './format';

const th = { padding: '5px 8px', textAlign: 'left', borderBottom: '2px solid var(--border)', fontSize: '11px', fontWeight: 600, color: 'var(--text-secondary)', whiteSpace: 'nowrap' };
const td = { padding: '4px 8px', borderBottom: '1px solid var(--border)', fontSize: '11px' };

const brakStyl = (n) => ({ ...td, textAlign: 'right', fontWeight: 600, color: n > 0 ? 'var(--danger)' : 'var(--success)' });

const PerMiesiac = ({ perMiesiac }) => {
  const lista = Array.isArray(perMiesiac) ? perMiesiac : [];
  return (
    <div className="card" data-testid="per-miesiac" style={{ fontSize: '12px' }}>
      <h3 style={{ margin: '0 0 8px', fontSize: '13px', fontWeight: 600 }}>Per miesiąc</h3>
      {lista.length === 0 ? (
        <div style={{ color: 'var(--text-muted)', fontSize: '11px' }}>Brak danych w zakresie</div>
      ) : (
        <div style={{ overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={th}>Miesiąc</th>
                <th style={{ ...th, textAlign: 'right' }}>W portalu</th>
                <th style={{ ...th, textAlign: 'right' }}>Brak faktur</th>
                <th style={{ ...th, textAlign: 'right' }}>Brak korekt</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(m => (
                <tr key={m.miesiac}>
                  <td style={{ ...td, fontWeight: 600, whiteSpace: 'nowrap' }}>{formatujMiesiac(m.miesiac)}</td>
                  <td style={{ ...td, textAlign: 'right' }}>{m.w_portalu ?? '—'}</td>
                  <td style={brakStyl(m.brak_faktur)}>{m.brak_faktur ?? '—'}</td>
                  <td style={brakStyl(m.brak_korekt)}>{m.brak_korekt ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PerMiesiac;
